import getShorterText from "Common/componentUtils/getShorterText";
import { withTooltip } from "Components/withPopover";
import classNames from "classnames";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import React, { memo, useMemo } from "react";
import Styled from "./btnDefaultToggler.styled";
function BtnDefaultToggler(props) {
    const elementAttr = useMemo(() => (props.id ? { id: props.id } : undefined), [props.id]);
    const Comp = useMemo(() => (props.attrTitle ? withTooltip(Styled.Button) : Styled.Button), [props.attrTitle]);
    const showErrorMessage = props.validationStatus === "invalid" && props.validationErrorMessage && !props.open;
    const errorMessage = useMemo(() => (React.createElement("div", { style: { position: "absolute", top: "100%", right: 0 }, className: "dx-overlay-wrapper dx-invalid-message dx-invalid-message-always" },
        React.createElement("div", { style: { top: -2, right: 0 }, className: "dx-overlay-content dx-invalid-message-content" }, props.validationErrorMessage))), [props.validationErrorMessage]);
    const defaultContent = useMemo(() => {
        if (props.content)
            return undefined;
        const resultCaption = isUndefined(props.selectedKeyCaption)
            ? props.caption
            : getShorterText(props.selectedKeyCaption, props.maxLength);
        return (React.createElement("span", { className: classNames("text-overflow-ellipsis d-inline-block nowrap", props.muteDefaultCaptionText && isUndefined(props.selectedKeyCaption) && "text-muted"), title: isString(resultCaption) ? resultCaption : "" }, resultCaption));
    }, [
        props.content,
        props.noCaret,
        props.maxLength,
        props.caption,
        props.muteDefaultCaptionText,
        props.selectedKeyCaption
    ]);
    return (React.createElement(Comp, { className: classNames(props.open && "active", !props.height && "h-auto", props.validationStatus === "invalid" && "border-danger-400", showErrorMessage && "position-relative", props.className), title: props.title, onClick: props.onClick, disabled: props.disabled, elementAttr: elementAttr, height: props.height, popoverContent: props.attrTitle, zIndex: props.zIndex, id: props.id },
        props.content || defaultContent,
        !props.noCaret && React.createElement("span", { className: "ml-0_5 caret" }),
        showErrorMessage && errorMessage));
}
export default memo(BtnDefaultToggler);
